import { render, staticRenderFns } from "./listaPedidosEspera.vue?vue&type=template&id=a01c43a6&scoped=true&"
import script from "./listaPedidosEspera.vue?vue&type=script&lang=js&"
export * from "./listaPedidosEspera.vue?vue&type=script&lang=js&"
import style0 from "./listaPedidosEspera.vue?vue&type=style&index=0&id=a01c43a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01c43a6",
  null
  
)

export default component.exports